
export const CompletionStatus = (work_request: any) => {


  const renderApproveCount = (work_request: any) => {
    let approved_count = 0

    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'Published') approved_count++
      })
    
    return approved_count.toFixed(0)
  }
  const renderReviewCount = (work_request: any) => {
    let review_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'For Approval' || element?.status === 'Published') review_count++
      })
    // work_request?.push({ review_count: review_count })
    return review_count.toFixed(0)
  }
  const renderRejectedAtReview = (work_request: any) => {
    let rejected_review_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'Rejected at Review' || element?.status === 'Open (Require Amending') rejected_review_count++
      })
    // work_request?.push({ review_count: review_count })
    return rejected_review_count.toFixed(0)
  }
  const renderRejectedAtApproval = (work_request: any) => {
    let rejected_approve_count = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'For Review (Require Amending)') rejected_approve_count++
      })
    // work_request?.push({ review_count: review_count })
    return rejected_approve_count.toFixed(0)
  }
   const renderRejectedAtApprovalForCreator = (work_request: any) => {
    let rejected_approve_count_creator = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
        if (element?.status === 'Rejected at Approval') rejected_approve_count_creator++
      })
    // work_request?.push({ review_count: review_count })
    return rejected_approve_count_creator.toFixed(0)
  }
  const renderDeleted = (work_request: any) => {
     let total_deleted = 0
    work_request?.questions?.length > 0 &&
      work_request?.questions?.map((element: any) => {
      
       if (element?.active ===  'false') {
        total_deleted++
      }
      })
    // work_request?.push({ review_count: review_count })
    return total_deleted.toFixed(0)
   
}
  const updatePercentage = () => {
    let overall_count: number = Math.ceil(
      (
       ((( ((work_request?.questions?.length - parseInt(renderRejectedAtReview(work_request)) -parseInt(renderDeleted(work_request))-parseInt(renderRejectedAtApprovalForCreator(work_request))) * 0.75) +
        (parseInt(renderReviewCount(work_request))-parseInt(renderRejectedAtApproval(work_request))) * 0.15)
          + (parseInt(renderApproveCount(work_request)) * 0.1))/work_request?.count))*100
        
      
      )
        
    // console.log("yyyyyyyyyyyyyyyyy", "overall_count", overall_count)
    // console.log("yyyyyyyyyyyyyyyyy", "renderRejectedAtReview", parseInt(renderRejectedAtReview(work_request)))
    // console.log("yyyyyyyyyyyyyyyyy", "renderDeleted", parseInt(renderDeleted(work_request)))
    // console.log("yyyyyyyyyyyyyyyyy", "renderRejectedAtApprovalForCreator", parseInt(renderRejectedAtApprovalForCreator(work_request)))
    // console.log("yyyyyyyyyyyyyyyyy", "renderReviewCount", parseInt(renderReviewCount(work_request)))
    // console.log("yyyyyyyyyyyyyyyyy", "renderRejectedAtApproval", parseInt(renderRejectedAtApproval(work_request)))
    //  console.log("yyyyyyyyyyyyyyyyy", "renderApproveCount", parseInt(renderApproveCount(work_request)))
    
      // (((work_request?.questions?.length - parseFloat(renderRejectedAtReview(work_request))) * 0.75) / work_request?.count +
      //   (parseFloat(renderReviewCount(work_request)) * 0.15) / work_request?.count +
      //   (parseFloat(renderApproveCount(work_request)) * 0.1) / work_request?.count) *
      //   100
    
  
    // updateCompletionStatus(work_request?.id, overall_count).then(() => {
    //   if (overall_count >= 100) updateWorkRequestStatus(work_request?.id, 'Closed')
    // })
  }
  return updatePercentage()
}
